module.exports = __webpack_public_path__ + "img/makeup-active.a4d2d904.png";